import React, { useState } from "react";
import "../../assets/welcome.css";

const Welcome = ({ user, onClose }) => {
  const [visible, setVisible] = useState(true);

  const handleClose = () => {
    // First fade out
    setVisible(false);

    // Then actually remove after animation completes
    setTimeout(() => {
      if (onClose) onClose();
    }, 500); // Match this to the CSS transition time
  };

  if (!user) return null;

  return (
    <div
      className={`welcome-page-overlay ${
        visible ? "welcome-page-visible" : "welcome-page-hidden"
      }`}
    >
      <div className="welcome-page-modal">
        <button className="welcome-page-close" onClick={handleClose}>
          ×
        </button>

        <div className="welcome-page-header">
          <h1>Welcome to XSM Basketball!</h1>
        </div>

        <div className="welcome-page-content">
          <p className="welcome-page-greeting">Hi {user.email}!</p>

          <div className="welcome-page-section">
            <h2>Verify Your Email</h2>
            <p>
              We've sent a verification link to your email address. Please check
              your inbox and click the link to verify your account.
            </p>
          </div>

          <div className="welcome-page-section">
            <h2>Next Steps</h2>
            <ul className="welcome-page-steps">
              <li>Verify your email address</li>
              <li>Complete your profile</li>
              <li>Explore our platform features</li>
              <li>Connect with other players</li>
            </ul>
          </div>

          <div className="welcome-page-section">
            <h2>Need Help?</h2>
            <p>
              If you have any questions or didn't receive the verification
              email, you can request a new one from your profile page.
            </p>
          </div>
        </div>

        <div className="welcome-page-footer">
          <button className="welcome-page-button" onClick={handleClose}>
            Let's Get Started
          </button>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
